jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
	countdown: {
		start(endTimeMillis, timeout, callback, finishedCallback) {
			callback(this.getRemainingTime(endTimeMillis));
			return setInterval(() => {
				const remaining = this.getRemainingTime(endTimeMillis);

				callback(remaining);
				if (remaining.total <= 0) {
					finishedCallback();
				}
			}, timeout);
		},

		stop(countdownInterval) {
			clearInterval(countdownInterval);
		},

		getRemainingTime(endTimeMillis) {
			const total = Date.parse(new Date(endTimeMillis)) - new Date().getTime();
			const seconds = Math.floor((total / 1000) % 60);
			const minutes = Math.floor((total / 1000 / 60) % 60);
			const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
			const days = Math.floor(total / (1000 * 60 * 60 * 24));

			return {
				total,
				days,
				hours,
				minutes,
				seconds,
			};
		},
	},
});
